import React from 'react';
import PropTypes from 'prop-types';
import InputTextNested from '../Form/InputTextNested';
import TextAreaNested from '../Form/TextAreaNexted';
import SelectIndustry from './Industry';

const CompanyInfo = ({ company, setCompany }) => {
  return (
    <section>
      <h3>Main Information</h3>
      {/* Company Name */}
      <InputTextNested
        title="Company Name"
        value={company?.companyName}
        name="companyName"
        requiredInput={true}
        nestedValue={setCompany}
        upperValue={company}
        containerClassName="formInputUnderline"
      />
      {/* Main Office Phone Number */}
      <InputTextNested
        title="Office Phone Number"
        value={company?.phoneOffice}
        name="phoneOffice"
        requiredInput={true}
        nestedValue={setCompany}
        upperValue={company}
        containerClassName="formInputUnderline"
      />
      {/* Company Website Link */}
      <InputTextNested
        title="Website"
        value={company?.website}
        name="website"
        nestedValue={setCompany}
        upperValue={company}
        containerClassName="formInputUnderline"
      />
      <SelectIndustry
        value={company?.industry}
        nestedValue={setCompany}
        upperValue={company}
        containerClassName="formInputUnderline"
      />
      {/* Notes */}
      <TextAreaNested
        title="Notes"
        name="notes"
        value={company?.notes}
        nestedValue={setCompany}
        upperValue={company}
        placeholder="Notes about the company"
        containerClassName="formInputUnderline"
      />
      <h3>Main Contact</h3>
      {/* Main Contact */}
      <InputTextNested
        title="Main Contact"
        value={company?.mainContact}
        name="mainContact"
        requiredInput={true}
        nestedValue={setCompany}
        upperValue={company}
        containerClassName="formInputUnderline"
      />
      {/* Email of company */}
      <InputTextNested
        title="Email"
        value={company?.email}
        name="email"
        nestedValue={setCompany}
        upperValue={company}
        requiredInput={true}
        containerClassName="formInputUnderline"
      />
      {/* Mobile Phone Number */}
      <InputTextNested
        title="Mobile Phone Number"
        value={company?.phoneMobile}
        name="phoneMobile"
        nestedValue={setCompany}
        upperValue={company}
        containerClassName="formInputUnderline"
      />
      <h3>Secondary Contact</h3>
      {/* Secondary Contact */}
      <InputTextNested
        title="Secondary Contact"
        value={company?.secondaryContact}
        name="secondaryContact"
        nestedValue={setCompany}
        upperValue={company}
        containerClassName="formInputUnderline"
      />
      {/* Email of company */}
      <InputTextNested
        title="Secondary Contact Email"
        value={company?.secondaryEmail}
        name="secondaryEmail"
        nestedValue={setCompany}
        upperValue={company}
        containerClassName="formInputUnderline"
      />
      {/* Mobile Phone Number */}
      <InputTextNested
        title="Mobile Phone Number"
        value={company?.secondaryPhone}
        name="secondaryPhone"
        nestedValue={setCompany}
        upperValue={company}
        containerClassName="formInputUnderline"
      />
    </section>
  );
};
CompanyInfo.propTypes = {
  company: PropTypes.shape({
    companyName: PropTypes.string,
    mainContact: PropTypes.string,
    secondaryContact: PropTypes.string,
    secondaryEmail: PropTypes.string,
    secondaryPhone: PropTypes.string,
    email: PropTypes.string,
    phoneOffice: PropTypes.string,
    phoneMobile: PropTypes.string,
    website: PropTypes.string,
    notes: PropTypes.string,
    industry: PropTypes.string,
  }),
  setCompany: PropTypes.func,
};

export default CompanyInfo;
